// import React, { useState } from "react";
// import { FaWhatsapp, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
// import "../social/Social.css";

// const Social = () => {
//   const [whatsappOpen, setWhatsappOpen] = useState(false);
//   const [phoneOpen, setPhoneOpen] = useState(false);
//   const [gmailOpen, setGmailOpen] = useState(false);
//   const openWhatsapp = () => {
//     setWhatsappOpen(true);
//     const phoneNumber = "+919311797248";
//     window.location.href = `https://wa.me/${phoneNumber}`;
//   };

//   const openPhone = () => {
//     setPhoneOpen(true);
//     const phoneNumber = "+919311797248";
//     window.open(`tel:${phoneNumber}`);
//   };


//   const openGmail = () => {
//     setGmailOpen(true);
//     const emailAddress = "info@gautamsolar.com";
//     window.open(`mailto:${emailAddress}`);
//   };

//   return (
//     <div className="contact-icons">
//       <div
//         className={`icon ${whatsappOpen ? "open" : ""}`}
//         onClick={openWhatsapp}
//       >
//         <FaWhatsapp size={20} />
//       </div>
//       <div className={`icon ${phoneOpen ? "open" : ""}`} onClick={openPhone}>
//         {/* <FaPhone size={20}/> */}
//         <FaPhoneAlt size={18} />
//       </div>
//       <div className={`icon ${gmailOpen ? "open" : ""}`} onClick={openGmail}>
//         <FaEnvelope size={20} />
//       </div>
//     </div>
//   );
// };

// export default Social;


// ---------------------------------------------
// import { useState } from "react";
// import {
//   FaWhatsapp,
//   FaEnvelope,
//   FaPhoneAlt,
//   FaFileInvoiceDollar,
// } from "react-icons/fa";
// import "../social/Social.css";

// const Social = () => {
//   const [whatsappOpen, setWhatsappOpen] = useState(false);
//   const [phoneOpen, setPhoneOpen] = useState(false);
//   const [gmailOpen, setGmailOpen] = useState(false);
//   const [quoteOpen, setQuoteOpen] = useState(false);

//   const openWhatsapp = () => {
//     setWhatsappOpen(true);
//     const phoneNumber = "+919311797248";
//     window.location.href = `https://wa.me/${phoneNumber.replace("+", "")}`;
//   };

//   const openPhone = () => {
//     setPhoneOpen(true);
//     const phoneNumber = "+919311797248";
//     window.open(`tel:${phoneNumber}`);
//   };

//   const openGmail = () => {
//     setGmailOpen(true);
//     const emailAddress = "info@gautamsolar.com";
//     window.open(`mailto:${emailAddress}`);
//   };

//   const getQuote = () => {
//     setQuoteOpen(true);

//     const footer =
//       document.querySelector("footer") ||
//       document.getElementById("footer");

//     if (footer) {
//       footer.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }

//     setTimeout(() => setQuoteOpen(false), 600);
//   };

//   return (
//     <div className="contact-icons">
//       {/* WhatsApp */}
//       <div
//         className={`icon ${whatsappOpen ? "open" : ""}`}
//         onClick={openWhatsapp}
//         role="button"
//         tabIndex={0}
//         aria-label="Contact us on WhatsApp"
//         onKeyDown={(e) => {
//           if (e.key === "Enter" || e.key === " ") {
//             e.preventDefault();
//             openWhatsapp();
//           }
//         }}
//       >
//         <FaWhatsapp size={20} />
//       </div>

//       {/* Phone */}
//       <div
//         className={`icon ${phoneOpen ? "open" : ""}`}
//         onClick={openPhone}
//         role="button"
//         tabIndex={0}
//         aria-label="Call us"
//         onKeyDown={(e) => {
//           if (e.key === "Enter" || e.key === " ") {
//             e.preventDefault();
//             openPhone();
//           }
//         }}
//       >
//         <FaPhoneAlt size={18} />
//       </div>

//       {/* Email */}
//       <div
//         className={`icon ${gmailOpen ? "open" : ""}`}
//         onClick={openGmail}
//         role="button"
//         tabIndex={0}
//         aria-label="Email us"
//         onKeyDown={(e) => {
//           if (e.key === "Enter" || e.key === " ") {
//             e.preventDefault();
//             openGmail();
//           }
//         }}
//       >
//         <FaEnvelope size={20} />
//       </div>

//       {/* Get a Quote */}
//       <button
//         type="button"
//         className={`icon quote-icon ${quoteOpen ? "open" : ""}`}
//         onClick={getQuote}
//         aria-label="Get a quote"
//         title="Get a Quote"
//       >
//         <FaFileInvoiceDollar size={20} />
//         <span className="quote-tooltip">Get a Quote</span>
//       </button>
//     </div>
//   );
// };

// export default Social;



import React, { useState } from "react";
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaFileInvoiceDollar,
} from "react-icons/fa";
import "../social/Social.css";

const Social = () => {
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const [gmailOpen, setGmailOpen] = useState(false);

  const openWhatsapp = () => {
    setWhatsappOpen(true);
    window.location.href = "https://wa.me/919311797248";
  };

  const openPhone = () => {
    setPhoneOpen(true);
    window.location.href = "tel:+919311797248";
  };

  const openGmail = () => {
    setGmailOpen(true);
    window.location.href = "mailto:info@gautamsolar.com";
  };

  const getQuote = () => {
    const footer =
      document.querySelector("footer") ||
      document.getElementById("footer");

    footer?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <button
        type="button"
        className="get-quote-tab"
        onClick={() => {
          document
            .getElementById("enquiry")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
      >
        Get a Quote
      </button>
    <div className="floating-contact">
      {/* Compact Get a Quote button */}

      {/* Original social icons */}
      <div className="contact-icons">
        <div
          className={`icon ${whatsappOpen ? "open" : ""}`}
          onClick={openWhatsapp}
          role="button"
          tabIndex={0}
          aria-label="WhatsApp"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openWhatsapp();
            }
          }}
        >
          <FaWhatsapp size={20} />
        </div>

        <div
          className={`icon ${phoneOpen ? "open" : ""}`}
          onClick={openPhone}
          role="button"
          tabIndex={0}
          aria-label="Call us"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openPhone();
            }
          }}
        >
          <FaPhoneAlt size={18} />
        </div>

        <div
          className={`icon ${gmailOpen ? "open" : ""}`}
          onClick={openGmail}
          role="button"
          tabIndex={0}
          aria-label="Email us"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openGmail();
            }
          }}
        >
          <FaEnvelope size={20} />
        </div>
      </div>
    </div>
    </>

  );
};

export default Social;

